window.app.factory("dataDownload", [
  function() {
    return function triggerDownload(
      data,
      mime = "application/octet-stream",
      filename
    ) {
      var newBlob = new Blob([data], { type: mime });

      // IE
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const url = window.URL.createObjectURL(newBlob);
      const link = document.createElement("a");

      if (filename) {
        link.download = filename;
      }

      link.setAttribute("type", "hidden");
      link.href = url;
      link.target = "_blank";

      // Firefox
      document.body.appendChild(link);

      link.click();
      link.remove();

      setTimeout(function() {
        window.URL.revokeObjectURL(url);
      }, 100);
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/dataDownload.js